import onLogError from './onLogError';
import { PAGE_TYPE } from '../constants/logger';

const getAngularScope = async (page, ngControllerElement) => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    onLogError({
      sourceName: 'getAngularScope',
      page: PAGE_TYPE[page] || page,
      error,
    });
    return undefined;
  }

  return window.angular.element(ngControllerElement || document.body)?.scope();
};

export default getAngularScope;
